export default "__VITE_ASSET__BXFjVfG2__"